import React, {Component} from 'react'
import PropTypes from 'prop-types'

class Testable extends Component {
  static propTypes = {testId: PropTypes.string.isRequired}

  render() {
    const {testId, className, ...props} = this.props

    return <div data-test-id={testId} className={className} {...props}/>
  }
}

export {Testable}
